export { tidy } from './tidy.js';
export { AiOrb } from './AiOrb.js';

/** The landing page's motion curve: screen changes are a 320 ms rise and fade on it. */
export const EASE = [0.16, 1, 0.3, 1] as const;
export const EASE_CSS = 'cubic-bezier(.16,1,.3,1)';

export const prefersReduced = (): boolean =>
  typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
